import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_URL } from '../models/api-url.token';
import { ISupportHandledUm } from '../support-handled-um.model';
import { ISupportHandledVm } from '../support-handled-vm.model';

@Injectable({ providedIn: 'root' })
export class OperatorSupportHandledService {
  private readonly baseUrl: string;

  constructor(private http: HttpClient, @Inject(API_URL) private apiUrl: string) {
    this.baseUrl = `${this.apiUrl}/OperatorSupportHandled`;
  }

  put(supportHandledUm: ISupportHandledUm): Observable<ISupportHandledVm> {
    const headers = this.createHeaders();
    return this.http.put<ISupportHandledVm>(this.baseUrl, supportHandledUm, { headers });
  }

  private createHeaders(): HttpHeaders {
    let headers = new HttpHeaders();
    const token = localStorage.getItem('authToken');
    if (token) headers = headers.set('Authorization', `Bearer ${token}`);
    return headers;
  }
}
